import { FC, PropsWithChildren } from "react";

import { useMediaQuery } from "@/common/hooks/useMediaQuery";
import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardButton, DashboardButtonProps } from "@/dashboard-design-system/DashboardButton";
import { ExternalLink as Launch } from "@/icons/outlined";

interface OpenFormProps {
  link?: string | null;
  variant?: "outlined" | "filled";
  size?: DashboardButtonProps["size"];
  vibe?: DashboardButtonProps["vibe"];
  onClick?: () => void;
  overrideLabel?: string;
  target?: string | null;
}

export const OpenForm: FC<PropsWithChildren<OpenFormProps>> = ({
  link,
  variant,
  vibe,
  size,
  onClick,
  overrideLabel,
  target = "_blank",
}) => {
  const { t } = useTranslate();
  const { isSmallScreen } = useMediaQuery();
  const label = overrideLabel || t("common", isSmallScreen ? "seeMyFormMobile" : "seeMyForm");

  return link ? (
    <DashboardButton
      variant={variant || "outlined"}
      href={link}
      target={target ?? undefined}
      vibe={vibe || "neutral"}
      endIcon={target === "_blank" ? <Launch /> : undefined}
      onClick={onClick}
      data-test="open-form"
      size={size}
    >
      {label}
    </DashboardButton>
  ) : null;
};
